import { useState } from "react"

import { adminApi } from "../axios"
import { formatAdminLoadError } from "./useAdminPaginatedQuery"

function formatCallingNumberError(error) {
  const data = error?.response?.data
  if (typeof data?.detail === "string") return data.detail
  if (typeof data?.twilio_voice_phone === "string")
    return data.twilio_voice_phone
  if (typeof data?.owner_user_id === "string") return data.owner_user_id
  if (Array.isArray(data?.twilio_voice_phone)) {
    return data.twilio_voice_phone.join(" ")
  }
  if (typeof data?.owner_user_id === "object" && data.owner_user_id?.[0]) {
    return data.owner_user_id[0]
  }
  return formatAdminLoadError(error, "Could not update calling number.")
}

export function useAdminCallingNumberMutations(onSuccess) {
  const [editRow, setEditRow] = useState(null)
  const [deleteRow, setDeleteRow] = useState(null)
  const [saving, setSaving] = useState(false)
  const [dialogError, setDialogError] = useState(null)

  async function handleSaveEdit(payload) {
    if (!editRow) return
    setSaving(true)
    setDialogError(null)
    try {
      await adminApi.updateCallingNumber(editRow.id, payload)
      setEditRow(null)
      onSuccess?.()
    } catch (error) {
      setDialogError(formatCallingNumberError(error))
    } finally {
      setSaving(false)
    }
  }

  async function handleConfirmDelete() {
    if (!deleteRow) return
    setSaving(true)
    setDialogError(null)
    try {
      await adminApi.deleteCallingNumber(deleteRow.id)
      setDeleteRow(null)
      onSuccess?.()
    } catch (error) {
      setDialogError(formatCallingNumberError(error))
    } finally {
      setSaving(false)
    }
  }

  function closeDialogs() {
    setEditRow(null)
    setDeleteRow(null)
    setDialogError(null)
  }

  return {
    editRow,
    setEditRow,
    deleteRow,
    setDeleteRow,
    saving,
    dialogError,
    handleSaveEdit,
    handleConfirmDelete,
    closeDialogs,
  }
}
